import script from "./EditProfilePage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProfilePage.vue?vue&type=script&setup=true&lang=js"

import "./EditProfilePage.vue?vue&type=style&index=0&id=5f59a5f6&lang=css"

const __exports__ = script;

export default __exports__